function isRecord(value) {
    return typeof value === "object" && value !== null;
}
function detectFirstDayOfWeek(locale) {
    try {
        const loc = new Intl.Locale(locale);
        const weekInfo = Reflect.get(loc, "weekInfo");
        if (isRecord(weekInfo)) {
            const firstDay = weekInfo["firstDay"];
            if (typeof firstDay === "number") {
                return firstDay === 7 ? 0 : firstDay;
            }
        }
        const getWeekInfo = Reflect.get(loc, "getWeekInfo");
        if (typeof getWeekInfo === "function") {
            const info = getWeekInfo.call(loc);
            if (isRecord(info)) {
                const firstDay = info["firstDay"];
                if (typeof firstDay === "number") {
                    return firstDay === 7 ? 0 : firstDay;
                }
            }
        }
    }
    catch {
        // Intl.Locale unsupported or invalid locale tag.
    }
    return 1; // ISO default (Monday)
}
/**
 * Builds a locale bundle from a BCP 47 locale tag using Intl APIs.
 */
export function buildDateLocale(locale, firstDayOfWeek) {
    const resolvedFirst = firstDayOfWeek ?? detectFirstDayOfWeek(locale);
    const monthFormatter = new Intl.DateTimeFormat(locale, { month: "long" });
    const monthShortFormatter = new Intl.DateTimeFormat(locale, {
        month: "short",
    });
    const dayNarrowFormatter = new Intl.DateTimeFormat(locale, {
        weekday: "narrow",
    });
    const dayShortFormatter = new Intl.DateTimeFormat(locale, {
        weekday: "short",
    });
    const monthNamesLong = [];
    const monthNamesShort = [];
    for (let m = 0; m < 12; m++) {
        const d = new Date(2024, m, 15);
        monthNamesLong.push(monthFormatter.format(d));
        monthNamesShort.push(monthShortFormatter.format(d));
    }
    const dayNamesNarrow = [];
    const dayNamesShort = [];
    for (let i = 0; i < 7; i++) {
        const d = new Date(2024, 0, 7 + i); // Jan 7, 2024 is Sunday.
        dayNamesNarrow.push(dayNarrowFormatter.format(d));
        dayNamesShort.push(dayShortFormatter.format(d));
    }
    return {
        locale,
        firstDayOfWeek: resolvedFirst,
        monthNamesLong,
        monthNamesShort,
        dayNamesNarrow,
        dayNamesShort,
    };
}
